// Copyright (c) 2017 Deere & Company

import PrepareAudit from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.prepareAudit,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    children: parentProps.children,
    queryParams: parentProps.location.query,
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PrepareAudit);



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/state-connector.js